module.exports = __webpack_public_path__ + "static/img/iconfont.c526fc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/iconfont.svg
// module id = xCPn
// module chunks = 1